module.exports = __webpack_public_path__ + "static/add-meiyu-qrcode.en-dabae22db54fa10265a3f643a44e6636.svg";